import NullAvatar from './NullAvatar';
import LabelPoint from './LabelPoints';

export default function PodiumtutorMini({ props, rank, tutor, handleClick}) {
    return (
        <div className="flex flex-column align-items-center relative" onClick={() => handleClick(tutor?.publicId)}>
            <div className="ranking-tutor-item relative mb-4">
                <div class="grid">
                    <div className="col-6 xs:col-12 md:col-12 lg:col-6">
                        <div>
                            <div className="ranking-tutor-avatar border-4 -mt-3">
                                {tutor ?
                                    <img sr src={tutor?.profileImage}
                                        style={{
                                            width: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    :
                                    <NullAvatar rank={rank} />
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-5 xs:col-12 md:col-12 lg:col-5">
                        <p className="text-info-txt-color keduall-typography text-12-normal-400">
                            {tutor && <span>#{rank}</span>}
                        </p>
                        <p className="keduall-typography text-16-semibold-600 text-center ranking-tutor-item-name mt-1">
                            {tutor?.name}
                            <span className={`fi fi-${tutor?.nationality} flag ml-2`}></span>
                        </p>
                        <p className="keduall-typography text-14-normal-400 text-center mt-1">
                            {tutor && <span>{tutor?.points.toLocaleString()}<LabelPoint props={props} /></span>}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}